<micro-picklist title="Groups" [all]="all" [(selectedIds)]="selectedItems" (selectedIdsChange)="onNgModelChange($event)"></micro-picklist>

